import { createRoot } from 'react-dom/client';
import '../../../packages/ui/src/tokens.css';
import './ui/ds/ds.css';
import { useGameStore } from '@campus/core';
import { App } from './App.js';
import { applyTheme } from './ui/ds/index.js';
import { captureInstallPrompt } from './lib/installApp.js';

// Thème choisi dans les Réglages (sombre par défaut), suivi à chaud.
applyTheme(useGameStore.getState().settings.theme);
useGameStore.subscribe((s) => s.settings.theme, applyTheme);

// Installation comme application (menu de l'avatar) : l'événement arrive tôt.
captureInstallPrompt();

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root not found');

createRoot(root).render(<App />);
